// TabsWidget.js
// The whole-composite display: every tab of the function's result, exactly as
// the Decode function UI shows it.

import React from 'react';
import CompositeOutputTabs from '../../common/CompositeOutputTabs';
import { exportFileName } from '../../../utils/excelExport';
import { runExportStamp } from '../../../utils/runDisplay';

function TabsWidget({ instanceState, companyName = null }) {
  return (
    <CompositeOutputTabs
      outputs={instanceState.outputs}
      outputsSummary={instanceState.outputsSummary}
      functionId={instanceState.functionId}
      companyName={companyName}
      chartSettings={instanceState.chartSettings}
      exportName={exportFileName(instanceState.functionName, runExportStamp(instanceState.run))}
      blockNames={instanceState.blockNames}
      chartMinHeight={260}
      fileHeight={260}
    />
  );
}

export default TabsWidget;
